import React from "react";

const Logical = () => {
  return (
    <div>
      <h1>Logical Component</h1>
      <p>Content for Logical goes here...</p>
    </div>
  );
};

export default Logical;
